import { useMutation } from '@tanstack/react-query';
import {
  questionnaireAnswer,
  updatePatientQuestionnaire,
  updatePatientQuestionnairePayload,
} from '../../../apis/questionnaire';

export function usePatientQuestionnaire() {
  const { mutate } = useMutation({
    mutationKey: ['update-patient-questionnaire'],
    mutationFn: (payload: updatePatientQuestionnairePayload) =>
      updatePatientQuestionnaire(payload),
  });

  const submitPatientQuestionnaire = (
    patientId: number | undefined,
    historyType: string,
    questionnaires: questionnaireAnswer[]
  ) => {
    if (!patientId) {
      return;
    }

    const payload: updatePatientQuestionnairePayload = {
      patient: {
        id: patientId,
        history_type: historyType,
        questionnaires,
      },
    };

    mutate(payload);
  };

  return {
    submitPatientQuestionnaire,
  };
}
